import React from "react";
import { Button } from "@similarweb/ui-components";
import { Textfield } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { isOpportunityListNameLongEnough } from "../../../helpers/helpers";
import {
    StyledCreateListForm,
    StyledCreateListSubmitSection,
    StyledCreateListInputContainer,
    StyledCreateListInputLabel,
} from "./styles";
import type { CreateListFormProps } from "./types";

const translate = i18nFilter();

const CreateListForm = ({ loading, onSubmit, onCancel, labelCreateBtn }: CreateListFormProps) => {
    const [name, setName] = React.useState("");
    const isNameLongEnough = isOpportunityListNameLongEnough(name);

    const handleSubmit = () => {
        if (isNameLongEnough) {
            onSubmit(name.trim());
        }
    };

    return (
        <StyledCreateListForm>
            <StyledCreateListInputContainer>
                <StyledCreateListInputLabel>
                    <I18n
                        data-automation="create-list-form.input-label"
                        translatable={{ key: "si.components.add_to_list_dropdown.create.label" }}
                    />
                </StyledCreateListInputLabel>
                <Textfield
                    autoFocus
                    maxLength={200}
                    defaultValue=""
                    onChange={setName}
                    dataAutomation="si-components-save-search-modal-input"
                    placeholder={translate("si.components.add_to_list_dropdown.create.placeholder")}
                />
            </StyledCreateListInputContainer>
            <StyledCreateListSubmitSection>
                <Button
                    type="flat"
                    onClick={onCancel}
                    dataAutomation="create-list-form.cancel-button"
                >
                    {translate("si.common.button.cancel")}
                </Button>
                <Button
                    type="primary"
                    isLoading={loading}
                    onClick={handleSubmit}
                    isDisabled={!isNameLongEnough || loading}
                    dataAutomation="create-list-form.submit-button"
                >
                    {labelCreateBtn || translate("si.common.button.save")}
                </Button>
            </StyledCreateListSubmitSection>
        </StyledCreateListForm>
    );
};

export default CreateListForm;
